/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTimecardsAndBreaks} from '../api'

 export const useQueryGetTimecardsAndBreaks = createReactQueryHook('getTimecardsAndBreaks', getTimecardsAndBreaks)
